var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogInMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,19.689a5.414,5.414,0,0,1,4.456-5.4l.231-.038a19.069,19.069,0,0,1,6.206,0l.231.038a5.414,5.414,0,0,1,4.456,5.4,2.069,2.069,0,0,1-2.034,2.1H7.035A2.069,2.069,0,0,1,5,19.689Z",
    transform: "translate(2.419 3.369)",
    fill: "none",
    stroke: "#1d9dff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.005,7.382a4.465,4.465,0,0,1-4.544,4.382A4.465,4.465,0,0,1,7.917,7.382,4.465,4.465,0,0,1,12.461,3,4.465,4.465,0,0,1,17.005,7.382Z",
    transform: "translate(2.749 2.127)",
    fill: "none",
    stroke: "#1d9dff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogInMobile);
export default __webpack_public_path__ + "static/media/logInMobile.f473a96f6080f6c1d509463583b683b4.svg";
export { ForwardRef as ReactComponent };